module.exports = __webpack_public_path__ + "static/media/health11.01893f1a.svg";